export default __webpack_public_path__ + "static/media/carE.e1363eeb.png";